import { createContext, useContext, useReducer, type Dispatch, type ReactNode } from "react";
import { interviewReducer, initialState } from "../engine/reducer";
import { familyWellnessTemplate } from "../templates/familyWellness";
import type { InterviewAction, InterviewState } from "../engine/types";

type InterviewContextValue = {
  state: InterviewState;
  dispatch: Dispatch<InterviewAction>;
};

const InterviewContext = createContext<InterviewContextValue | null>(null);

/**
 * Mounted ABOVE the tab router (§8) so the CHW view's live row reads the
 * exact same state the Run-a-check-in view mutates — one InterviewProvider
 * per browser tab, matching the no-application-side-persistence property:
 * this state lives in memory only and is gone on refresh.
 */
export function InterviewProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(interviewReducer, initialState(familyWellnessTemplate, "en"));

  return <InterviewContext.Provider value={{ state, dispatch }}>{children}</InterviewContext.Provider>;
}

export function useInterviewState(): InterviewContextValue {
  const ctx = useContext(InterviewContext);
  if (!ctx) {
    throw new Error("useInterviewState must be used within an InterviewProvider");
  }
  return ctx;
}
